module.exports = __webpack_public_path__ + "static/img/3.22abdb74.svg";